import { render } from "./AppMain.vue?vue&type=template&id=00d81a54&scoped=true"
import script from "./AppMain.vue?vue&type=script&lang=js"
export * from "./AppMain.vue?vue&type=script&lang=js"

import "./AppMain.vue?vue&type=style&index=0&id=00d81a54&scoped=true&lang=css"
import "./AppMain.vue?vue&type=style&index=1&id=00d81a54&lang=scss"

import exportComponent from "/Users/arkane/Dev/Web/Projects/era.proj/era.dev.local/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00d81a54"]])

export default __exports__